// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"328":"admin","378":"user"}[chunkId] || chunkId) + "." + {"277":"758d5c0f","328":"08c15506","378":"28a35fff"}[chunkId] + ".js";
};